<template>
    <div class="review-wrapper p-4">
        <img class="mw-100 rounded" v-if="image" :src="image" />
        <p class="my-4 text-center">{{ question_message }}</p>
        <div>
            <button class="btn btn-block swell-btn"
                @click="$emit('site', review_site)"
                v-for="review_site of sites"
                :key="review_site.site"
                :class="[!review_site.custom ? 'text-left btn-' + replaceSpace(review_site.site) : 'text-center']"
                :style="{backgroundColor: review_site.custom ? review_site.color : '', color: review_site.custom ? '#fff' : ''}">
                    <img class="rounded-circle health-grades mr-4" src="/img/healthgrades-icon.png" v-if="review_site.site == 'healthgrades' && !review_site.custom"/>
                    <i v-if="review_site.site != 'healthgrades' && !review_site.custom" class="fab fa-fw mr-4" :class="[!review_site.custom ? 'fa-' + removeSpace(review_site.site) : '']"></i>
                {{ review_site.site | capitalize }}
            </button>
        </div>
        <div class="my-2 text-center" v-if="allowPrivateFeedback">
            <small>
                <a class="text-primary cursor-pointer" @click="$emit('feedback')">
                    Click here
                </a>
                 to leave private feedback for {{location_placeholder}}
            </small>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            image: { default: '' },
            sites: { default: () => ([]) },
            question: { default: null },
            locationName: { default: null },
            allowPrivateFeedback: { default: true }
        },

        computed: {
            question_message() { return this.question || 'Where would you like to leave your review?'; },
            location_placeholder() { return this.locationName || '[location name]'; }
        },

        methods: {
            replaceSpace(text){ if (text) return text.replace(' ', '-'); },

            removeSpace(text){ if (text) return text.replace(' ', ''); }
        }
    }
</script>

<style>
    .health-grades{
        max-width: 10%;
    }
</style>
